export default "__VITE_ASSET__709875c4__"